import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'

import { zoomInDown } from 'react-animations';
import { fadeInDown } from 'react-animations';
import Radium, {StyleRoot} from 'radium';


const stylesLigh = {
  fadeInDown: {
    animation: 'x 3s',
    animationName: Radium.keyframes(fadeInDown, 'fadeInDown')
  }
}
const stylesLighTwo = {
  fadeInDown: {
    animation: 'x 2s',
    animationName: Radium.keyframes(fadeInDown, 'fadeInDown')
  }
}
const stylesLighThree = {
  fadeInDown: {
    animation: 'x 1s',
    animationName: Radium.keyframes(fadeInDown, 'fadeInDown')
  }
}



class Service extends Component {
  render() {
    return (
     

        <section className="ptb ptb-sm-80 service_top " >
            <div className="wow fadeIn container text-center" id="#services">
                
              
                <div className="row">
                    <div className="col-md-6">
                    
                    <StyleRoot>

                    <div className="lay" style={stylesLigh.fadeInDown}>
                       
                    <div className="serv">
                    <img src="/assets/img/feuille.png" className="leaf"/>
                        <h5>Techniciens Conseils</h5>
                        
                        <p>Accompagner quotidiennement les agriculteurs dans leur approche de la fertilisation biologique et s’engager dans la voie d’avenir du développement durable.</p>
                        <p> Au-delà du conseil technique, c’est une approche et une analyse globale de l’exploitation qui sont proposées aux agriculteurs. Un conseil sur mesure pour ...</p>
                        <p><a href="/technicien-conseil"><button  className="btn btn-md btn-black-line btn_services with_leaf tech_cons_btn_home">Lire la suite</button></a></p>
                    </div>
                    </div>
                    </StyleRoot>
                    </div>


                    <div className="col-md-6">
                     
                    <StyleRoot>

                    <div className="lay" style={stylesLigh.fadeInDown}>
                       
                    <div className="serv">
                    <img src="/assets/img/feuille.png" className="leaf"/>
                        <h5>Recherche & innovation</h5>
                        
                        <p>C’est à Keur Moussa, à quelques pas de son usine, que Green Agro Business a choisi d’implanter son périmètre de tests et démonstrations et faire de la recherche et innover ses solutions respectueuses de l’environnement.</p>
                        <p> Grâce aux échanges quotidiens avec nos techniciens conseils terrain, notre équipe ...</p>
                        <p><a href="/recherche-et-innovation"><button  className="btn btn-md btn-black-line btn_services with_leaf">Lire la suite</button></a></p>
                    </div>
                    </div>
                    </StyleRoot>
                    </div>
                    </div>
                    
             
            </div>
        </section>

       
        

    )
  }
}
export default Service;



// WEBPACK FOOTER //
// ./src/components/services.jsx